import React from "react";
import { Avatar } from "components/ui";

/**
 * Avatar for images we store (genre logos, CSV banners, film stills).
 *
 * R-388: it used to re-sign CDN images as S3 GETs with guest Cognito
 * credentials; the guest role has had no S3 access since 11/10. The CDN
 * serves these images publicly, so we show the CDN URL itself. A bare S3 key
 * (no scheme) is turned into its CDN URL. The name is kept so callers do not
 * change.
 */
export const resolveImageUrl = (src?: string | null): string | undefined => {
  if (!src) return undefined;
  if (/^(https?:|data:|blob:)/i.test(src)) return src;
  const cdn = (process.env.REACT_APP_AWS_CDN_URL || "").replace(/\/+$/, "");
  return cdn ? `${cdn}/${src.replace(/^\/+/, "")}` : src;
};

const SecureAvatar = ({ src, ...props }: { src?: string | null; [key: string]: any }) => {
  return <Avatar {...props} src={resolveImageUrl(src)} />;
};

export default SecureAvatar;
